import { cn } from "@/lib/utils";

interface SectionWrapperProps extends React.HTMLAttributes<HTMLElement> {
    children: React.ReactNode;
}

export const SectionWrapper = ({ children, className, ...props }: SectionWrapperProps) => {
    return (
        <section className={cn("w-full py-12 md:py-16 lg:py-20", className)} {...props}>
            <div className="container px-4 md:px-6">
                {children}
            </div>
        </section>
    );
};
